// extracted by mini-css-extract-plugin
module.exports = {"container":"summaryFeatureGroupComponent_container__aAxwG","featureContainer":"summaryFeatureGroupComponent_featureContainer__0i1Zo"};